import { render, staticRenderFns } from "./MultiHisInfoSelector.vue?vue&type=template&id=4f794fdd&scoped=true&"
import script from "./MultiHisInfoSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiHisInfoSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MultiHisInfoSelector.vue?vue&type=style&index=0&id=4f794fdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f794fdd",
  null
  
)

export default component.exports